import { apiGet, apiPatch, apiPost } from './client';
import { MARKETING_CONSENT_VERSION } from '../consent/versions';

export function getProfile() {
  return apiGet('/api/v1/profile');
}

export function completeProfile({
  organization,
  role,
  country,
  termsAccepted,
  termsDocVersion,
  marketingConsentFirstparty,
}) {
  const body = {
    organization,
    role,
    country,
    terms_accepted: termsAccepted,
    terms_doc_version: termsDocVersion,
  };
  if (typeof marketingConsentFirstparty === 'boolean') {
    body.marketing_consent_firstparty = marketingConsentFirstparty;
  }
  return apiPost('/api/v1/profile', body);
}

export function submitPhiAttestation({ attestationVersion, calculatorSessionId }) {
  return apiPost('/api/v1/phi-attestation', {
    attestation_version: attestationVersion,
    calculator_session_id: calculatorSessionId,
  });
}

export function updateProfileDetails({ organization, role, country }) {
  return apiPatch('/api/v1/profile', { organization, role, country });
}

export function updateMarketingConsent(marketingConsentFirstparty) {
  return apiPatch('/api/v1/profile/marketing-consent', {
    marketing_consent_firstparty: marketingConsentFirstparty,
    consent_version: MARKETING_CONSENT_VERSION,
  });
}
